import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import isMobile from 'is-mobile';

import ClassRoomMenu from './classroom_menu';
import { getModulo, marcarLeido, getCompletos, cambiarActualModulo } from '../actions';
import { formatHTML } from '../utils';

class ClassRoom extends Component {
  constructor(props){
    super(props);
    let redirect = "no";
    if(this.props.modulo !== null && (this.isntSet(this.props.usuario) ||
              this.isntSet(this.props.usuario.cursosDisponibles) ||
              this.props.usuario.cursosDisponibles.indexOf(this.props.modulo.idcurso) < 0)) {
      redirect = `/curso/${this.props.modulo.idcurso}`;
    }

    this.state = {
      contenidoActual: null,
      redirect
    };

    this.abrirContenido = this.abrirContenido.bind(this);
  }

  isntSet(value){
    return value===undefined || value===null;
  }

  componentDidMount(){
    this.props.getModulo(this.props.match.params.idclase);
  }

  componentWillReceiveProps(newProps){
    let contenidoActual=null;
    if (newProps.modulo!==null &&
      newProps.modulo.error===undefined &&
      newProps.modulo.contenidos.length > 0) {
      contenidoActual = newProps.modulo.contenidos[0];
    }
    this.setState({ contenidoActual });
  }

  abrirContenido(contenidoActual){
    this.closeNav();
    this.setState({ contenidoActual });
  }

  renderNavButtons(){
    let modulo = this.props.modulo;
    let actual = this.state.contenidoActual;
    let anterior = null, siguiente = null;
    let mobile = isMobile();
    //mobile = true;

    if(modulo===null || actual===null){
      return "";
    }

    let indexActual = modulo.contenidos.indexOf(actual);

    if(modulo.contenidos.length===1){
      return (
        <li className="list-group-item controls-nav">
          <div className={ mobile ? "btn-group-vertical" : "btn-group" }>
            <Link
              to={`/curso/${this.props.modulo.idcurso}`}
              className="btn btn-light"
              replace >
              Volver al Curso
            </Link>
          </div>
        </li>
      );
    }

    if(indexActual!==0){
      anterior = (
        <a
          onClick={()=>this.abrirContenido(modulo.contenidos[indexActual-1])}
          className="btn btn-light">
          Anterior
        </a>
      );
    }

    if(indexActual !== modulo.contenidos.length-1){
      siguiente = (
        <a
          onClick={()=>this.abrirContenido(modulo.contenidos[indexActual+1])}
          className="btn btn-light">
          Siguiente
        </a>
      );
    }else{
      siguiente = (
        <Link
          to={`/curso/${this.props.modulo.idcurso}`}
          className="btn btn-light" >
          Volver al Curso
        </Link>
      );
    }

    return (
      <li className="list-group-item controls-nav">
        <div className={ mobile ? "btn-group-vertical" : "btn-group" }>
          {anterior!==null?anterior:""}

          <a onClick={(evt)=>this.openNav()} className="btn btn-light">
            <i className="fas fa-bars"></i> Ver contenido del Módulo
          </a>

          {siguiente!==null?siguiente:""}
        </div>
      </li>
    );
  }

  render(){
    if(this.props.usuario!==null && this.props.modulo!==null && this.props.modulo.completos === undefined){
      this.props.getCompletos(this.props.modulo.id, this.props.usuario.id);
    }

    if(this.state.curso !== undefined && this.state.curso.costo !== "0" && this.state.redirect!=="no") {
      NotificationManager.warning("Compre el curso para tener acceso a él");
      return (<Redirect to={this.state.redirect} />);
    }
    let modulo = this.props.modulo;
    let contenido = this.state.contenidoActual;

    if( this.props.curso !== null && this.props.curso.costo !== "0"
      && this.props.usuario!==null && this.props.usuario.id===undefined){
      NotificationManager.warning("Por favor inicie sesión antes de continuar");
      return (<Redirect to="/login" />);
    }
    if( contenido!==undefined && contenido!==null &&
      this.props.usuario!==null && this.props.usuario.id!==undefined ){
      this.props.marcarLeido(this.props.usuario.id, contenido.id);
    }

    if (modulo===null) {
      return (
        <section id="course-detail">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Cargando...</h5>
              </div>
            </div>
          </div>
        </section>
      );
    } else if(modulo.error!==undefined) {
        return (
          <section id="course-detail">
            <div className="container">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">{modulo.error}</h5>
                </div>
              </div>
            </div>
          </section>
        );
    } else if(contenido === null) {
      return (
        <section id="course-detail">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">No se ha encontrado contenido en el módulo</h5>
              </div>
            </div>
          </div>
        </section>
      );
    }
    console.log(contenido);
    return (
      <section id="classroom">
        <ClassRoomMenu abrirContenido={this.abrirContenido}/>

        <div id="non-side-nav">

          <div className="card">
            <div className="card-header">
              {contenido.titulo}
            </div>
            <ul className="list-group list-group-flush">
              {isMobile() ? "" : this.renderNavButtons()}
              {
                (contenido.texto!==undefined && contenido.texto!=="")?
                  (<li className="list-group-item">
                    {formatHTML(contenido.texto)}
                  </li>)
                :""
              }
              {
                (contenido.audio.url!=="")?
                  (<li className="list-group-item">
                    <h2>{contenido.audio.titulo}</h2>
                    <audio controls>
                     <source src={contenido.audio.url} type="audio/mpeg" />
                      Tu navegador no soporta estos contenidos.
                    </audio>
                  </li>)
                :""
              }
              {
                (contenido.video!==undefined && contenido.video!=="")?
                (<li className={isMobile() ? "list-group-item mobile" : "list-group-item"}>
                  <iframe title={`video-media-${contenido.id}`} src={`https://www.youtube.com/embed/${contenido.video}`} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
                </li>)
                :""
              }
              { (contenido.pdf!==undefined && contenido.pdf.trim()!=="") ?
                  (!isMobile() ?
                    (<li className="list-group-item">
                      {
                        (contenido.pdf.includes(".pdf", contenido.pdf.length - 4)) ?
                        (<object data={contenido.pdf} type="application/pdf">
                            <embed src={contenido.pdf} type="application/pdf" />
                        </object>):
                        <iframe title={contenido.pdf} src={'https://view.officeapps.live.com/op/embed.aspx?src=https://aulas.ceis.com.py'+contenido.pdf} width='100%' height='640px' frameborder='0'/>
                      }
                      <a href={'https://aulas.ceis.com.py'+contenido.pdf} className="btn btn-primary btn-block" target="_blank" download>Descargar</a>
                    </li>) :
                    (<li className="list-group-item">
                      <a href={`https://docs.google.com/viewerng/viewer?url=https://aulas.ceis.com.py/${contenido.pdf}`} target="_blank">
                        Ver Contenido PDF
                      </a>
                    </li>)
                  )
                :""
              }
              {this.renderNavButtons()}


            </ul>
          </div>
        </div>
      </section>
    );
  }


  /* FOR THE SIDE NAV*/
  /* Set the width of the side navigation to 250px and the left margin of the
    page content to 250px and add a black background color to body */
  openNav() {
    document.getElementById("custom-side-nav").style.width = "350px";
    document.getElementById("non-side-nav").style.marginLeft = "350px";
  }

  /* Set the width of the side navigation to 0 and the left margin of the page
    content to 0, and the background color of body to white */
  closeNav() {
    document.getElementById("custom-side-nav").style.width = "0";
    document.getElementById("non-side-nav").style.marginLeft = "0";
  }
}

function mapStateToProps({ modulo, usuario, curso }) {
  return { modulo, usuario, curso };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    getModulo, marcarLeido, getCompletos, cambiarActualModulo
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassRoom);



// WEBPACK FOOTER //
// ./src/containers/classroom.js